/* ============================================================================
   fix-28 — En móvil, la barra inferior de Safari/Chrome tapaba el pie del
   carrito (total, «Finalizar compra», iconos de pago).

   El cajón mide `100dvh` (main.css) y el documento se congela al abrirlo
   (`SideDrawer.open()`), así que el navegador nunca retrae su barra; y la
   unidad `dvh` no descuenta siempre esa barra (iOS 26, barra flotante).

   Variante conservadora, la de la review del 16-sep: el documento sigue
   congelado como en cualquier otro cajón y el carrito mide lo que de verdad se
   ve, `visualViewport.height`, publicado en `--lej-vvh` y actualizado en cada
   cambio del viewport. El pie queda siempre a la vista; la barra del navegador
   no se esconde, y no hace falta que lo haga.

   Solo escribe una variable CSS en `<html>` y solo bajo 750 px: `main.js`,
   `lej-cart.js` y el resto de cajones quedan intactos. El CSS que la usa está
   en `lej-cart-viewport.css`, bajo `cart-drawer[open]`.
   ========================================================================== */
(function () {
  const vv = window.visualViewport;
  if (!vv) return;

  const MOBILE = window.matchMedia('(max-width: 749px)');
  const VAR = '--lej-vvh';
  const root = document.documentElement;
  let frame = 0;

  function sync() {
    frame = 0;
    if (!MOBILE.matches) {
      root.style.removeProperty(VAR);
      return;
    }
    root.style.setProperty(VAR, `${Math.round(vv.height)}px`);
  }

  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(sync);
  }

  vv.addEventListener('resize', schedule);
  MOBILE.addEventListener('change', schedule);
  // Al abrir el cajón el valor tiene que estar fresco: el teclado o una
  // rotación pueden haberlo cambiado sin que hubiera carrito a la vista.
  document.addEventListener('on:cart-drawer:before-open', sync);
  sync();
}());
